import { Checkbox } from 'primereact/checkbox';
import styled from 'styled-components';
import { DISABLED_CHECKBOX_FONT_COLOR } from '../../../styles/fonts/MCFontConstants';
import { sizes } from 'src/styles/Media.styled';

export const CheckboxWrapper = styled.div`
    display: ${({ checkboxWrapperDisplay }) =>
        checkboxWrapperDisplay ? checkboxWrapperDisplay : 'flex'};
    align-items: ${({ alignItemDirection }) =>
        alignItemDirection ? alignItemDirection : ''};
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : ''};
`;

export const StyledCheckbox = styled(Checkbox)`
    &.p-checkbox {
        cursor: ${({disabled}) =>
            disabled ? 'not-allowed !important' : 'pointer'};
        width: ${({width}) => (width ? width : '20px !important')};
        height: ${({height}) => (height ? height : '20px !important')};
        margin: ${({margin}) => (margin ? margin : '0px')};
    }
    &.p-checkbox .p-checkbox-box {
        border: ${({ checkboxBorder, disabled }) =>
            checkboxBorder
                ? checkboxBorder
                : `2px solid ${disabled ? DISABLED_CHECKBOX_FONT_COLOR : '#555555'} !important`};
        background: ${({background}) =>
            background ? background : '#ffffff'};
        width: ${({width}) => (width ? width : '20px !important;')};
        height: ${({height}) => (height ? height : '20px !important;')};
        box-shadow: none !important;
        background-color: ${({disabled}) => disabled && '#00000029'};
    }
    &.p-checkbox .p-checkbox-box.p-highlight {
        background: ${({checkedBgColor}) =>
            checkedBgColor ? checkedBgColor : '#555555'} !important;
    }
    &.p-checkbox .p-checkbox-box .p-checkbox-icon {
        font-size: ${({width, height, checkIconSize}) => {
            if (checkIconSize) return checkIconSize;
            const size = width || height || '20px';
            const numericSize = parseInt(size);
            return numericSize <= 14 ? `${numericSize - 4}px` : '14px';
        }};
    }
    ${({ hoverEffect, checkboxBorder }) =>
            hoverEffect &&`
            .p-checkbox-box:hover {
            background-color: inherit !important;
            border: ${checkboxBorder} !important;
            box-shadow: none !important;
            cursor: pointer !important;
        }`
    }
    
    ${({ disableFocusEffect, checkboxBorder }) =>
            disableFocusEffect &&`
            .p-checkbox-box.p-focus {
            box-shadow: none !important;
            border: ${checkboxBorder} !important;
        }`
    }

`;

export const StyledLabel = styled.label`
    color: ${({ disabled, labelStyleObj }) =>
        disabled ? DISABLED_CHECKBOX_FONT_COLOR : (labelStyleObj?.color || 'inherit')};
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    user-select: none;
    font-size: ${({ labelStyleObj }) => labelStyleObj?.fontSize || 'inherit'};
    font-weight: ${({ labelStyleObj }) => labelStyleObj?.fontWeight || 'inherit'};
    font-family: ${({ labelStyleObj }) => labelStyleObj?.fontFamily || 'inherit'};
    margin: ${({ labelStyleObj }) => labelStyleObj?.margin || '0'};
    padding: ${({ labelStyleObj }) => labelStyleObj?.padding || '0'};
    text-align: ${({ labelStyleObj }) => labelStyleObj?.textAlign || 'inherit'};
    letter-spacing: ${({ labelStyleObj }) => labelStyleObj?.letterSpacing || 'inherit'};
    opacity: ${({ labelStyleObj }) => labelStyleObj?.opacity || 'inherit'};
    padding-left: ${({ labelStyleObj }) => labelStyleObj?.paddingLeft || '0'};
    line-height: ${({ labelStyleObj }) => labelStyleObj?.lineHeight || 'inherit'};
    /* Add more style mappings as needed */
`;
export const CheckboxWrapperContainer = styled.div`
    padding-bottom: ${({ isSurgeryReviewPage }) =>
        isSurgeryReviewPage && window.innerWidth < sizes.mobileDevice ? '19px' : '0px'};
    padding-top: ${({ isConsignmentReviewPage }) =>
        isConsignmentReviewPage && window.innerWidth < sizes.mobileDevice ? '6px' : '0px'};
`;